export default __webpack_public_path__ + "static/media/strangeAndUnusual-logo.6bf4b015.svg";